
import { Rate } from "../../margin/objects/rate";
import { Column } from "../objects/column";
import { MarginListCriteria } from "../objects/marginListCriteria";
import { OrganisationTripListConfiguration } from "../objects/organisationTripListConfiguration";


export const ORGANISATION_MARGIN_MODULE = 'ORGANISATION_MARGIN_MODULE';

export const EMPTY_ORGANISATION_MARGIN_LIST_CRITERIA: MarginListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    // filters: EMPTY_NETWORK_FILTERS,
    search: ''
};
export const MARGIN_COLUMN: Column[] = [
    {
        label: 'name',
        field_name: 'NAME',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'content-types',
        field_name: 'CONTENT_TYPE',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'destination',
        field_name: 'DESTINATION',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'commission',
        field_name: 'COMMISSION',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'type',
        field_name: 'TYPE',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'currency',
        field_name: 'CURRENCY',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'start-date',
        field_name: 'START_DATE',
        checked: false,
        order_by: 'start_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'end-date',
        field_name: 'END_DATE',
        checked: false,
        order_by: 'end_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: true,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: true,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'activated',
        field_name: 'ACTIVATED',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }
];

export const EMPTY_ORGANISATION_MARGIN_LIST_CONFIGURATION: OrganisationTripListConfiguration = {
    columns: MARGIN_COLUMN,
    preferences: []
};


export const EMPTY_RATE: Rate = {
    applied_under: null,
    currency: null,
    rate: 0,
    rate_type: 'FIX'
};